// Single source of truth for environment-dependent config. Previously this was
// hardcoded (and inconsistently so — 3 different files each had their own copy of
// the API base URL, one of them a stale droplet IP) across apiservices/apiService.ts,
// helpers/api/apiCore.ts, and utils/ApiService.tsx. All three now import from here.
//
// Falls back to the production values when REACT_APP_* vars aren't set. This
// must fail *safe* toward production, not toward localhost - the repo has no
// committed .env file (see .gitignore: .env/.env.local/etc are all excluded),
// so whatever ships to production relies entirely on REACT_APP_* being set by
// the hosting platform's own env config. A localhost fallback here (as this
// briefly was) means any gap in that platform config - env var typo'd, not
// set for a new environment, etc. - silently sends real users' browsers to
// http://localhost:3005 after actions like password reset (dev-plan
// [29 Sept 2026] Update 3) instead of failing loudly. For local development,
// create your own .env.local (already gitignored, never committed) with:
//   REACT_APP_API_BASE_URL=http://localhost:4001
//   REACT_APP_ADMIN_LOGIN_BASE_URL=http://localhost:3005
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.biharsportsmashaal.in";

export const ADMIN_LOGIN_BASE_URL =
  process.env.REACT_APP_ADMIN_LOGIN_BASE_URL || "https://users.biharsportsmashaal.in";

// AES key used to obscure the session cookie client-side. This is NOT real
// encryption (the key ships in the JS bundle either way) — it only prevents casual
// inspection of the cookie value. Moving it to an env var at least stops it being
// the literal same hardcoded string across all 4 dashboards' source trees.
export const SESSION_COOKIE_SECRET =
  process.env.REACT_APP_SESSION_SECRET ||
  "49720f6edc5c2840fb376e3c2b205cdf85d54e4868010f7f3edb7f59cfe073f7";

export const SESSION_COOKIE_NAME = "_enco_data14_ga";
